import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import FAQSection from "@/components/FAQSection";
import {
  ArrowLeft, ChevronRight, Calendar, MessageCircle, Phone, GraduationCap,
  Scissors, Heart, Shield, Users, MapPin, Building2, Microscope, Sparkles,
  Target, Brain, HandHeart, Stethoscope, Award, Activity
} from "lucide-react";

const expertise = {
  cancers: [
    "Ovarian Cancer (Early & Advanced Stage)",
    "Cervical Cancer",
    "Uterine (Endometrial) Cancer",
    "Vulval & Vaginal Cancer",
    "Rare Gynecologic Malignancies",
  ],
  surgical: [
    "Major Cytoreductive (Debulking) Surgeries",
    "HIPEC (Hyperthermic Intraperitoneal Chemotherapy)",
    "Laparoscopic Cancer Surgery",
    "Robotic-Assisted Gynecologic Surgery",
    "Pelvic Exenteration (Complex Cancer Surgery)",
  ],
  benign: [
    "Endometriosis (Deep Infiltrating Endometriosis)",
    "Ovarian Cysts",
    "Uterine Fibroids (Tumors)",
  ],
  preventive: [
    "Cancer Screening (Pap Smear, HPV Testing)",
    "High-Risk Cancer Evaluation",
    "Preventive Oncology & Early Detection Programs",
  ],
};

const clinicalPrinciples = [
  { icon: Target, text: "Early and accurate diagnosis" },
  { icon: Brain, text: "Evidence-based treatment planning" },
  { icon: Scissors, text: "Minimally invasive surgery whenever possible" },
  { icon: Heart, text: "Organ and fertility preservation (when safe and appropriate)" },
  { icon: Users, text: "Multidisciplinary cancer care coordination" },
  { icon: HandHeart, text: "Compassionate emotional support throughout treatment" },
];

const hospitals = [
  "Manipal Hospitals, EM Bypass (formerly Medica Superspecialty Hospital)",
  "Manipal Hospitals, Mukundapur",
  "Manipal Hospitals, Broadway",
  "Manipal Hospitals, Saltlake",
];

const philosophyPoints = [
  "Clear communication and patient education",
  "Transparent treatment planning",
  "Emotional support for patients and families",
  "Focus on quality of life and long-term outcomes",
];

const patientExperience = [
  "Clear and easy to understand medical explanations",
  "Supportive and empathetic consultation experience",
  "Structured and well-planned treatment pathways",
  "High level of surgical confidence and expertise",
];

const areasServed = [
  "Mukundapur", "EM Bypass", "Salt Lake", "Phoolbagan",
  "Kankurgachi", "Garia", "Kasba", "Ballygunge", "South Kolkata",
];

const stats = [
  { value: "10+", label: "Years of Experience" },
  { value: "1000+", label: "Complex Cancer Cases" },
  { value: "4", label: "Hospital Affiliations" },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55 } },
};

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.06 } },
};

export default function FaqPage() {
  return (
    <>
      <Helmet>
        <title>
          Dr. Neha Agarwal – Gynecologic Oncologist in Kolkata | Cancer & Robotic Surgeon
        </title>

        <meta
          name="description"
          content="Dr. Neha Agarwal is a leading gynecologic oncologist in Kolkata specializing in ovarian, cervical, uterine cancer, HIPEC, robotic and laparoscopic cancer surgery."
        />
      </Helmet>
      <div className="bg-[#F9F9F6]">

        <FAQSection />
      </div>
    </>
  );
}
